module.exports = __webpack_public_path__ + "static/media/stock.e8548b92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stock.svg
// module id = 19
// module chunks = 0